import {Utils} from 'services/common/utils';
import {PATH_LOGIN, PATH_LOGOUT, PATH_REFRESH_TOKEN, POST_LOG_ACCESS} from 'constants/AppPath';
import {BehaviorSubject} from 'rxjs';
import {APP_CODE} from 'constants/AppProps';
import store from "reactRedux/store/store";
import {fetchUser, updateAccess} from "reactRedux/action/userAction";
import {POST_LOG_ACCESS_PATH} from "../../constants/AppPath";
import {RESPONSE_STATUS} from "../../constants/AppProps";
import moment from "moment";

const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));

export const AuthenticationService = {
    login,
    logout,
    isLogin,
    restoreUserInfo,
    logAccessPath,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() {
        return currentUserSubject.value
    }
};

export function authHeader() {
    // return authorization header with jwt token
    const currentUser = AuthenticationService.currentUserValue;
    //Thuc hien refresh token neu sap het han
    _refreshToken();
    if (currentUser && currentUser.accessToken) {
        /*store.dispatch(
            updateAccess(_updateLastAccess())
        );*/
        return {Authorization: currentUser.type + " " + currentUser.accessToken};
    } else {
        return {};
    }
}

async function login(username, password, func) {
    //return Utils.get(PATH_LOGIN, {
    return Utils.postLogin(PATH_LOGIN, {
        "username": username,
        "password": password,
        "appId": APP_CODE
    }, function (data) {
        if (data && data.data && data.data.status && data.data.status === RESPONSE_STATUS.SUCCESS) {
            let dataLogin = {
                type: "Bearer",
                accessToken: data.data.data.tokenData.accessToken,
                refreshToken: data.data.data.tokenData.refreshToken,
                // accessTokenExpirationSecond: 18000,
                // refreshTokenExpirationSecond: 12000,
                userId:	data.data.data.userId,
                username: data.data.data.username,
                shopCode: data.data.data.shopCode,
                passwordExpiredStatus: false
            };
            var strJwt = Object.assign(dataLogin, _updateAccessTime(data.data.data.tokenData.accessTokenExpiredAt));
            localStorage.setItem('currentUser', JSON.stringify(strJwt));
            currentUserSubject.next(strJwt);
            //luu thong tin user vao redux
            store.dispatch(
                fetchUser(strJwt)
            );
        }

        if (func) {
            func(data);
        }
        //return data;
    }, true);
};

function logout() {
    if (null != AuthenticationService.currentUserValue) {
        // Utils.postLogout(PATH_LOGOUT, {}, null, false);
    }
    //
    localStorage.removeItem('currentUser');
    currentUserSubject.next(null);
    store.dispatch(
        fetchUser({})
    );
    //
};

async function _refreshToken() {
    try {
        if (_checkRefresh()) {
            Utils.post(PATH_REFRESH_TOKEN, {
                "refreshToken": AuthenticationService.currentUserValue.refreshToken
            }, (res) => _restoreCurrentUser(res));
        }
    } catch (error) {
    }
}

function _restoreCurrentUser(data) {
    if (data.data.status === RESPONSE_STATUS.SUCCESS) {
        const user = Object.assign(AuthenticationService.currentUserValue, _updateAccessTime(data.data.data.tokenData.accessTokenExpiredAt));
        user["accessToken"] = data.data.data.tokenData.accessToken;
        user["refreshToken"] = data.data.data.tokenData.refreshToken;
        localStorage.setItem('currentUser', JSON.stringify(user));
        currentUserSubject.next(user);
        //luu thong tin user vao redux
        store.dispatch(
            fetchUser(user)
        );
    }
}

function isLogin() {
    const currentUser = AuthenticationService.currentUserValue;
    if (!currentUser || !currentUser.validTo) {
        return false;
    }
    let nowTime = moment().utc(7).valueOf();
    let currTime = moment(currentUser.validTo).utc(7).valueOf();
    return currentUser && currentUser.accessToken && (nowTime < currTime);
}

function _updateAccessTime(accessExpire) {
    var accessTime = {};
    accessTime["validTo"] = moment(accessExpire, "YYYY-MM-DD HH:mm:ss").utc(7);
    return accessTime;
}

function _updateLastAccess() {
    var lastAccess = {};
    var nowTime = new Date();
    lastAccess["lastAccess"] = nowTime.getTime();

    return lastAccess;
}

function restoreUserInfo() {
    const currentUser = AuthenticationService.currentUserValue;
    if (currentUser && currentUser.accessToken) {
        store.dispatch(
            fetchUser(currentUser)
        );
        /*store.dispatch(
            updateAccess(_updateLastAccess())
        );*/
    }
}

function _checkRefresh() {
    let check = false;
    const uInfo = store.getState();
    let nowTime = moment().utc(7).valueOf();
    if (uInfo && uInfo.user.info) {
        let valid = uInfo.user.info.validTo.utc(7).valueOf();
        check = Math.abs(valid - nowTime) < 300000;
    }

    return check;
}

function logAccess(id) {
    //Utils.post(POST_LOG_ACCESS, {"moduleId": id});
}

function logAccessPath(path) {
    if (path && path !== "/") {
        //Rxxx
        // Utils.post(POST_LOG_ACCESS_PATH, {"appCode": APP_CODE, "path": path});
    }
}